import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/auth.css';

export const sections = {
  privacy: [
    {
      title: '1. Какие данные мы собираем',
      text: 'При использовании мессенджера «Трынди» мы обрабатываем: имя и адрес электронной почты, указанные при регистрации; аватар; сообщения и передаваемые файлы; статус активности; настройки оформления; данные о взаимодействии с сервисом (время отправки сообщений, звонки).',
    },
    {
      title: '2. Как мы используем данные',
      text: 'Данные используются исключительно для обеспечения работы мессенджера: доставки сообщений, хранения переписки и файлов, отображения профилей, обработки звонков, работы AI-ассистента, обеспечения безопасности и поддержки пользователей.',
    },
    {
      title: '3. Хранение данных',
      text: 'Данные хранятся на серверах, обеспечивающих работу сервиса (база данных, файловое хранилище). Секреты и учётные данные защищены и не хранятся в открытом виде. Доступ к данным имеют только технические компоненты сервиса, необходимые для их обработки.',
    },
    {
      title: '4. Передача данных третьим лицам',
      text: 'Мы не продаём и не передаём ваши данные третьим лицам, за исключением случаев, предусмотренных законодательством, либо когда это необходимо для функционирования сервиса (например, почтовый сервис для отправки писем подтверждения, облачный AI-сервис для генерации изображений по вашему запросу).',
    },
    {
      title: '5. Ваши права',
      text: 'Вы можете: изменить данные профиля в настройках; отключить уведомления для любого чата; удалить чаты и сообщения; удалить свой аккаунт. Для запроса на удаление данных или иных вопросов напишите на serg_company@vk.com.',
    },
    {
      title: '6. Изменения политики',
      text: 'Мы можем обновлять настоящую политику конфиденциальности. Актуальная версия всегда доступна на этой странице. Продолжение использования сервиса после изменений означает согласие с обновлённой политикой.',
    },
  ],
  terms: [
    {
      title: '1. Общие условия',
      text: 'Регистрируясь в мессенджере «Трынди», вы соглашаетесь с настоящими правилами. Использование сервиса означает принятие правил в полном объёме. Если вы не согласны — пожалуйста, не используйте сервис.',
    },
    {
      title: '2. Регистрация и аккаунт',
      text: 'Вы обязуетесь указывать достоверные данные при регистрации и несёте ответственность за сохранность своего аккаунта. Запрещено передавать доступ к аккаунту третьим лицам. Рекомендуемый возраст пользователей — от 14 лет.',
    },
    {
      title: '3. Запрещённое использование',
      text: 'Запрещается: рассылка спама; размещение противоправного контента, угроз, оскорблений; нарушение авторских прав; попытки взлома сервиса или чужих аккаунтов; распространение вредоносных программ; фишинг; использование сервиса для мошенничества.',
    },
    {
      title: '4. Контент пользователей',
      text: 'Вы несёте ответственность за размещаемые сообщения и файлы. Администрация вправе удалять нарушения и приостанавливать или блокировать аккаунты, нарушающие настоящие правила.',
    },
    {
      title: '5. Ограничение ответственности',
      text: 'Сервис предоставляется «как есть». Мы прилагаем усилия для бесперебойной работы, однако не гарантируем отсутствия сбоев и не несём ответственности за косвенные убытки, связанные с использованием или невозможностью использования сервиса.',
    },
    {
      title: '6. Изменения правил',
      text: 'Мы можем обновлять настоящие правила. Актуальная версия всегда доступна на этой странице. Продолжение использования сервиса после изменений означает согласие с обновлёнными правилами.',
    },
  ],
};

export default function LegalPage({ type }) {
  const navigate = useNavigate();
  const isPrivacy = type === 'privacy';
  const list = sections[isPrivacy ? 'privacy' : 'terms'];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <div className="legal-container">
      <div className="legal-card">
        <div className="legal-header">
          <h1>{isPrivacy ? 'Политика конфиденциальности' : 'Правила пользования'}</h1>
          <span className="legal-sub">Мессенджер «Трынди» · последнее обновление: август 2026 г.</span>
        </div>
        {list.map((s) => (
          <div key={s.title} className="legal-section">
            <h2>{s.title}</h2>
            <p>{s.text}</p>
          </div>
        ))}
        <div className="legal-actions">
          {isPrivacy ? (
            <button className="auth-link-btn" onClick={() => navigate('/terms')}>Правила пользования</button>
          ) : (
            <button className="auth-link-btn" onClick={() => navigate('/privacy')}>Политика конфиденциальности</button>
          )}
          <button className="auth-link-btn" onClick={() => navigate(-1)}>← Назад</button>
        </div>
      </div>
    </div>
  );
}